import { render, staticRenderFns } from "./ProjectPlatformInstagram.vue?vue&type=template&id=7593671a"
import script from "./ProjectPlatformInstagram.vue?vue&type=script&lang=ts"
export * from "./ProjectPlatformInstagram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports